import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { UndoButton, DBTextArea } from '_components';
import { getGoalSentenceWC } from '_helpers';
import styles from './Common.module.css';
import { WCGoalDropDown } from './WCGoalDropDown';

class PatientCareCenterNoteGoalsGoalDetailsWCDelete extends React.Component {

    goalValueChanged() {
        if (!this.props.goalsUpdated) {
            this.props.updateBitField(this.props.noteId, 'PTNOTE', 'NTNO', this.props.pk, 'NTGOALSUPDATED', true);
        }
    }

    undoDeleteGoal() {
        this.props.updateBitField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELETED', false);
        if (this.props.goal.GODELREASON) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.id, 'GODELREASON');
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            this.props.activityName !== prevProps.activityName &&
            this.props.goal.GOGOALLEVEL &&
            !(Object.keys(this.props.goalLevels).map(key => this.props.goalLevels[key].id)).includes(this.props.goal.GOGOALLEVEL)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOGOALLEVEL');
        }
        if (this.props.noteId === prevProps.noteId &&
            this.props.goal.GONO === prevProps.goal.GONO &&
            this.props.activityName !== prevProps.activityName &&
            this.props.goal.GOCLOF &&
            !(Object.keys(this.props.clofGoalLevels).map(key => this.props.clofGoalLevels[key].id)).includes(this.props.goal.GOCLOF)) {
            this.props.clearField(this.props.noteId, 'PTGOALS', 'GONO', this.props.goal.GONO, 'GOCLOF');
        }
    }


    render() {
        return (
            <div className={styles.goal_detail_wrapper}>
                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label_req}>Activity:</span>
                    <span className={styles.goal_detail_activity}>
                        <WCGoalDropDown
                            noteId={this.props.noteId}
                            entity='PTGOALS'
                            entityKeyColumn='GONO'
                            entityKeyValue={this.props.goal.GONO}
                            isWc={true}
                            className={styles.goal_level_dropdown_wc}
                            onChange={() => this.goalValueChanged()}
                        />
                    </span>

                    <span>
                        <span className={styles.goal_detail_fav} />
                        <span className={styles.goal_detail_delete}>
                            <UndoButton title='Undo Delete' size='extra-small' onClick={() => this.undoDeleteGoal()} />
                        </span>
                    </span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_detail_label}>Goal:</span>
                </div>

                <div className={styles.goal_detail_row}>
                    <span className={styles.goal_sentence}>{getGoalSentenceWC(this.props.activityName, this.props.goalLevelSentence, this.props.goal)}</span>
                </div>

                <span>
                    <div className={styles.goal_detail_row}>
                        <span className={styles.goal_detail_label_req_top}>Reason:</span>
                        <span className={styles.goal_input}>
                            <DBTextArea
                                noteId={this.props.noteId}
                                entity='PTGOALS'
                                entityKeyColumn='GONO'
                                entityKeyValue={this.props.goal.GONO}
                                field='GODELREASON'
                                className={styles.text_area}
                                onChange={() => this.goalValueChanged()}
                                rows={6}
                            />
                        </span>
                    </div>
                </span>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let goal = state.entities.notes.PTGOALS[ownprops.id];
    let activityName = goal.GOMGNO ? state.entities.masterData.PTMASTERGOALS[goal.GOMGNO].MGNAME : '';
    let goalLevelSentence = goal.GOGOALLEVEL ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOGOALLEVEL].GLSENTENCETXT : '';
    let pdc = undefined;
    if (noteType === 1 && state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC) {
        pdc = state.entities.notes.PTEVAL[pk].EVSUBWCJOBREQPDC;
    } else {
        pdc = state.entities.admissions[epno].jobReqPdc;
    }

    let clofGoalLevels = [];
    if (goal.GOMGNO) {
        // get based on XREF
        let glnos = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
            .filter(key => {
                return (state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO);
            })
            .map(key => state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO);

        clofGoalLevels = Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
            .filter(key => {
                return (glnos.includes(state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO));
            })
            .sort((a, b) => {
                let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                    });
                let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                    .find(key => {
                        return state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXMGNO === goal.GOMGNO &&
                            state.entities.masterData.PTMASTERGOALLEVELXREF[key].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                    });
                let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                return aOrder - bOrder;
            })
            .map(key => {
                return {
                    id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                    value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                    sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                    clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                }
            })
    }

    let goalLevels = Object.keys(clofGoalLevels)
        .filter(key => {
            return clofGoalLevels[key].clofOnly === false;
        })
        .map(key => {
            return clofGoalLevels[key];
        });

    let savePanelVisible = state.ui.notes[noteId].saveGoalFavoriteVisible;
    let goalFavorites = Object.keys(state.entities.notes.PTGOALFAVORITES)
        .filter(key => {
            return (noteType === 1 && state.entities.notes.PTGOALFAVORITES[key].GFEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.PTGOALFAVORITES[key].GFNTNO === pk)
        })
        .sort((a, b) => state.entities.notes.PTGOALFAVORITES[a].GFNAME.localeCompare(state.entities.notes.PTGOALFAVORITES[b].GFNAME))
        .map(key => state.entities.notes.PTGOALFAVORITES[key]);


    let mgnos = Object.keys(state.entities.masterData.PTMASTERGOALPDCXREF)
        .filter(key => {
            return (state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXWPNO === pdc);
        })
        .map(key => state.entities.masterData.PTMASTERGOALPDCXREF[key].GPXMGNO);



    let masterGoals = Object.keys(state.entities.masterData.PTMASTERGOALS)
        .filter(key => {
            return mgnos.includes(state.entities.masterData.PTMASTERGOALS[key].MGNO) &&
                state.entities.masterData.PTMASTERGOALS[key].MGWORKCOMP === true;
        })
        .sort((a, b) => {
            return state.entities.masterData.PTMASTERGOALS[a].MGORDER - state.entities.masterData.PTMASTERGOALS[b].MGORDER;
        })
        .map(key => {
            return {
                id: state.entities.masterData.PTMASTERGOALS[key].MGNO,
                value: state.entities.masterData.PTMASTERGOALS[key].MGNAME,
            }
        })
    let goalsUpdated = noteType !== 1 ? state.entities.notes.PTNOTE[pk].NTGOALSUPDATED : true;

    let clofPrev = goal.GOCLOFPREV ? state.entities.masterData.PTMASTERGOALLEVELS[goal.GOCLOFPREV].GLNAME : undefined;
    let progressPrev = goal.GOGPNOPREV ? state.entities.masterData.PTMASTERGOALPROGRESS[goal.GOGPNOPREV].GPNAME : undefined;


    return {
        noteId: noteId,
        noteType,
        pk,
        goal: goal,
        masterGoals: masterGoals,
        activityName: activityName,
        goalLevelSentence: goalLevelSentence,
        clofGoalLevels: clofGoalLevels,
        goalLevels: goalLevels,
        savePanelVisible: savePanelVisible,
        goalFavorites: goalFavorites,
        goalsUpdated,
        clofPrev,
        progressPrev
    };
}

const connectedPatientCareCenterNoteGoalsGoalDetailsWCDelete = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteGoalsGoalDetailsWCDelete);
export { connectedPatientCareCenterNoteGoalsGoalDetailsWCDelete as PatientCareCenterNoteGoalsGoalDetailsWCDelete };

